<template>
  <div class="price">
    <container>
      <template v-slot:header>
        {{$ml.get(`Price per unit`)}}
      </template>
      <form class="content" @submit.self="saveFertilizerCost($event)">
          <app-number-input
            v-model="obj.price"
            :hint="obj.unit"
            :min="0"
          />
          <app-sel
            key-name="value"
            label-name="label"
            :label="$ml.get(`Select unit`)"
            :items="units"
            v-model="obj.unit"
            styling="inline"
            hide-top-label
          >
            <template v-slot="{ items }">
              <app-sel-opt
                v-for="item in items"
                :value="item"
                :key="item.value"
              >
                <!-- {{ item.label }} -->
                {{ $store.getters['unit/getLabel'](item.label) }}
              </app-sel-opt>
            </template>
          </app-sel>

          <app-btn type="submit">{{ $ml.get('Save') }}</app-btn>

      </form>
      <div class="currency">
        <p>
          {{ $ml.get(`Your currency is:`) }}
          <b>{{ $store.getters['user/currency'].name }} ({{ $store.getters['user/currency'].symbol }})</b>
        </p>
        <router-link :to="`/dashboard/account`">{{ $ml.get('Change currency') }}</router-link>
      </div>
      <!-- {{ data }} -->
    </container>
  </div>
</template>

<script>
import Container from "@/components/common/HeadedContainer"
import API from "@/api"

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      obj : {
        id: this.data.id,
        price: 0,
        unit: (this.data.type == 'SOLID') ? 'kg' : 'L',
      }
    }
  },
  created() {
    this.obj.price = this.data.cost ? this.$store.getters['unit/convert']('kg', this.data.cost) : 0
  },
  computed: {
    units() {
      let state = this.data.type;
      if(state == 'SOLID') {
        return [
          {
           value: 'kg',
           label: this.$store.getters['unit/getLabel']('kg'),
          },
          // {
          //  value: 'ton',
          //  label: this.$ml.get(`ton`),
          // },
          // {
          //  value: 'lb',
          //  label: this.$ml.get(`lb`),
          // },
        ];
      } else if(state == 'Liquid' || state == 'Acid'){
        return [
          {
           value: 'L',
           label: this.$store.getters['unit/getLabel']('L'),
          },
          // {
          //  value: 'm3',
          //  label: this.$ml.get(`m3`),
          // },
          // {
          //  value: 'gal',
          //  label: this.$ml.get(`gal`),
          // },
        ];
      } else {
        return false;
      }
    }
  },
  methods: {
    saveFertilizerCost(e) {
      e.preventDefault();
      let obj = JSON.parse(JSON.stringify(this.obj))
      obj.price = this.$store.getters['unit/unConvert']('kg', obj.price)
      return API.fertilizers.saveFertilizerCost(obj)
        .then(res => {
          this.$store.dispatch('fertilizers/getFertilizer');
        })
        .catch(err => {

        });
    },

  },
  components: {
    Container
  }
}
</script>

<style lang="scss" scoped>
  .price {
    .content {
      width: 100%;
      padding: 15px;
      display: flex;
      align-items: center;
      .app-number-input {
        min-width: 160px;
        margin-right: 16px;
      }
      .app-sel {
        min-width: 100px;
        margin-right: 16px;
      }
      .app-btn {
        margin-right: 16px;
      }
    }
    .currency {
      width: 100%;
      padding: 0 15px 15px 15px;
      // display: flex;
      // align-items: center;
      p {
        margin: 0;
        padding-right: 16px;
      }
      a {
        font-size: 12px;
      }
    }
  }
</style>
